export default __webpack_public_path__ + "static/media/DoubleDay10_750x600.ae741680.jpg";